@if (!isImageLoaded) {
  <mat-spinner></mat-spinner>
}

<img [src]="imageData"
     [alt]="alternativeText"
     #imageElement
     class="image-thumbnail"
     [class.loading]="!isImageLoaded"/>
